module.exports = __webpack_public_path__ + "static/media/aside-bg.3f02de92.png";